/** Hook that checks whether the current portal user is an admin.
 *
 * Calls GET /api/metrics/admin-check once the user is authenticated and
 * caches the result for the session via react-query.
 */

import { useQuery } from "@tanstack/react-query";

import { checkAdminStatus, type AdminCheckResponse } from "../lib/adminCheck";

export interface UseIsAdminResult {
  isAdmin: boolean;
  adminName: string | null;
  loading: boolean;
}

export function useIsAdmin(enabled: boolean = true): UseIsAdminResult {
  const { data, isLoading } = useQuery<AdminCheckResponse>({
    queryKey: ["admin", "check"],
    queryFn: checkAdminStatus,
    enabled,
    staleTime: 5 * 60 * 1000,
    retry: false,
  });

  return {
    isAdmin: data?.is_admin === true,
    adminName: data?.admin?.name ?? null,
    loading: isLoading,
  };
}
